import { useTranslation } from "react-i18next";
import { useAuth } from "../../auth/useAuth";
import { useSelection } from "../../context/SelectionContext";
import { Select } from "../ui/Select";

export function OrgSelector() {
  const { t } = useTranslation();
  const { associations } = useAuth();
  const { orgId, customerId, operationId, setOrg, setCustomer, setOperation } = useSelection();

  const orgs = associations ?? [];
  const selectedOrg = orgs.find((a) => a.org_id === orgId);
  const customers = selectedOrg?.customers ?? [];
  const selectedCustomer = customers.find((c) => c.id === customerId);
  const operations = selectedCustomer?.operations ?? [];

  return (
    <div className="flex items-center gap-2">
      {orgs.length > 1 && (
        <Select
          value={orgId ?? ""}
          onChange={(e) => setOrg(e.target.value ? Number(e.target.value) : null)}
          options={orgs.map((a) => ({ value: a.org_id, label: a.org_name }))}
          placeholder={t("common:selector.orgPlaceholder")}
          className="h-8 !py-0"
        />
      )}

      {customers.length > 1 && (
        <Select
          value={customerId ?? ""}
          onChange={(e) => setCustomer(e.target.value ? Number(e.target.value) : null)}
          options={customers.map((c) => ({ value: c.id, label: c.legal_name ? c.legal_name : `#${c.id}` }))}
          placeholder={t("common:selector.customerPlaceholder")}
          className="h-8 !py-0"
        />
      )}

      {operations.length > 1 && (
        <Select
          value={operationId ?? ""}
          onChange={(e) => setOperation(e.target.value ? Number(e.target.value) : null)}
          options={operations.map((o) => ({ value: o.id, label: o.name }))}
          placeholder={t("common:selector.operationPlaceholder")}
          className="h-8 !py-0"
        />
      )}
    </div>
  );
}
